import "./Bg.css"

export default function Bg(){
    return(
        <div className="bg-container">
        
        </div>
    )
}